// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/chatbot.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Seccion1_container__LQxtt {
    padding-top: 80px;
    padding-bottom: 60px;
}

.Seccion1_first-info-image__jZNAe {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.Seccion1_info-text__Ge7BH {
    padding: 70px 0;
}

.Seccion1_info-text__Ge7BH p {
    font-size: 25px;
    line-height: 28px;
    letter-spacing: 0.02em;
    margin-bottom: 50px;
}

.Seccion1_info-text__Ge7BH p span {
    font-size: 28px;
    font-weight: 700;
}

.Seccion1_image-background__5zMiA {
    height: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    background-size: contain;
}


/* SECTION REPORT */
.Seccion1_report-container__jpvNl {
    margin-top: 80px;
}

.Seccion1_report-container-wrapper__yB1sH {
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);
}

.Seccion1_report-image-items__RjyC1 {
    display: grid;
    grid-template-columns: 60% 40%;
    padding-bottom: 30px;
    border-bottom: 1px solid #C5C5CA;
}

.Seccion1_report-image__hLrKv {
    padding-right: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 30px;
}

.Seccion1_report-image__hLrKv img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Seccion1_report-image__hLrKv a {
    text-decoration: none;
    width: max-content;
}

.Seccion1_report-items__GPRR8 {
    padding: 0 10px 0 40px;
}

.Seccion1_report-items__GPRR8 ul li {
    margin-bottom: 40px;
    font-size: 22px;
    color: var(--black-text);
}

.Seccion1_report-description__dWirx {
    margin-top: 30px;
    text-align: center;
    font-size: 22px;
    color: var(--black-text);
}

.Seccion1_report-subdescription__Y9DHb {
    display: block;
    margin-top: 10px;
    font-family: "Tenorite", sans-serif;
    font-size: 17px;
    text-align: center;
}

.Seccion1_report-subdescription__Y9DHb a {
    cursor: pointer;
    text-decoration: underline;
}


.Seccion1_section-items-container__ofh\\+v {
    margin-top: 100px;
    padding: 60px 0 80px;
    background: var(--gradient-main);
}

.Seccion1_section-items__bPoOl h2 {
    text-align: center;
    font-size: 46px;
}

.Seccion1_section-items__bPoOl > p {
    margin: 30px 0 50px;
}

.Seccion1_section-items__bPoOl p {
    text-align: center;
    font-size: 24px;
}

.Seccion1_items-list__fTm6p {
    display: flex;
    justify-content: center;
    gap: 3%;
}

.Seccion1_item-detail__U\\+2qv {
    flex: 1 1;
    background-color: white;
    border-radius: 15px;
    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);
}

.Seccion1_item-image__n6vXI {
    width: 60%;
    height: auto;
    margin: 0 auto;
}

.Seccion1_item-image__n6vXI img {
    width: 100%;
    height: 100%;
}

.Seccion1_item-detail__U\\+2qv p {
    font-weight: 700;
    margin-top: 10px;
    padding: 0 15px 10px;
}


@media screen and (max-width: 1536px) {
    .Seccion1_first-info-image__jZNAe {
        grid-template-columns: 60% 40%;
    }

    .Seccion1_info-text__Ge7BH {
        padding: 60px 0;
    }

    .Seccion1_info-text__Ge7BH p {
        font-size: 24px;
    }

    .Seccion1_info-text__Ge7BH p span {
        font-size: 28px;
    }

    .Seccion1_image-background__5zMiA {
        background-position: center right;
    }


    /* REPORT */
    .Seccion1_report-image__hLrKv {
        padding-right: 30px;
    }

    .Seccion1_report-items__GPRR8 ul li {
        margin-bottom: 30px;
        font-size: 20px;
    }

    .Seccion1_report-description__dWirx {
        font-size: 20px;
    }


    .Seccion1_section-items__bPoOl h2 {
        font-size: 40px;
    }

    .Seccion1_section-items__bPoOl p {
        font-size: 22px;
    }
}

@media screen and (max-width: 1200px) {
    .Seccion1_first-info-image__jZNAe {
        grid-template-columns: 60% 40%;
    }

    .Seccion1_info-text__Ge7BH {
        padding: 40px 0;
    }

    .Seccion1_info-text__Ge7BH p {
        font-size: 20px;
    }

    .Seccion1_info-text__Ge7BH p span {
        font-size: 24px;
    }


    /* REPORT */
    .Seccion1_report-image__hLrKv {
        padding-right: 20px;
    }

    .Seccion1_report-items__GPRR8 ul li {
        margin-bottom: 25px;
        font-size: 18px;
    }

    .Seccion1_report-description__dWirx {
        font-size: 18px;
    }

    .Seccion1_report-subdescription__Y9DHb {
        font-size: 15px;
    }


    .Seccion1_section-items__bPoOl h2 {
        font-size: 36px;
    }

    .Seccion1_section-items__bPoOl p {
        font-size: 20px;
    }

    .Seccion1_items-list__fTm6p {
        gap: 2%;
    }
}

@media screen and (max-width: 992px) {
    .Seccion1_first-info-image__jZNAe {
        grid-template-columns: 55% 45%;
    }

    .Seccion1_info-text__Ge7BH {
        padding: 20px 0;
    }

    .Seccion1_info-text__Ge7BH p {
        font-size: 18px;
    }

    .Seccion1_info-text__Ge7BH p span {
        font-size: 22px;
    }


    /* REPORT */
    .Seccion1_report-image-items__RjyC1 {
        grid-template-columns: none;
    }

    .Seccion1_report-image__hLrKv {
        padding: 0 50px;
        grid-row: 2;
    }

    .Seccion1_report-items__GPRR8 {
        grid-row: 1;
        padding-left: 30px;
    }



    .Seccion1_section-items__bPoOl p {
        font-size: 18px;
    }

    .Seccion1_items-list__fTm6p {
        flex-wrap: wrap;
        column-gap: 3%;
        row-gap: 20px;
    }

    .Seccion1_item-detail__U\\+2qv {
        flex: none;
        width: 28%;
    }


}

@media screen and (max-width: 768px) {
    .Seccion1_container__LQxtt {
        padding-top: 60px;
    }

    .Seccion1_first-info-image__jZNAe {
        display: flex;
        flex-direction: column-reverse;
    }

    .Seccion1_info-text__Ge7BH {
        padding: 10px 5px;
        text-align: center;
    }

    .Seccion1_info-text__Ge7BH p {
        margin-bottom: 30px;
    }

    .Seccion1_info-image__zx2B0 {
        height: 350px;
    }


    /* REPORT */
    .Seccion1_report-image__hLrKv {
        padding: 0 30px;
    }

    .Seccion1_report-items__GPRR8 ul li {
        margin-bottom: 20px;
    }


    .Seccion1_image-background__5zMiA {
        background-position: center;
    }

    .Seccion1_section-items__bPoOl h2 {
        font-size: 34px;
    }
}

@media screen and (max-width: 576px) {
    .Seccion1_info-text__Ge7BH p {
        font-size: 16px;
        line-height: 22px;
    }

    .Seccion1_info-text__Ge7BH p span {
        font-size: 20px;
    }

    .Seccion1_info-image__zx2B0 {
        height: 300px;
    }


    /* REPORT */
    .Seccion1_report-container-wrapper__yB1sH {
        padding: 25px 10px;
    }

    .Seccion1_report-image__hLrKv {
        padding: 0;
    }

    .Seccion1_report-items__GPRR8 {
        padding-left: 20px;
    }

    .Seccion1_report-items__GPRR8 ul li {
        font-size: 16px;
    }

    .Seccion1_report-description__dWirx {
        font-size: 16px;
    }

    .Seccion1_report-subdescription__Y9DHb {
        font-size: 14px;
    }


    .Seccion1_section-items__bPoOl h2 {
        font-size: 30px;
    }

    .Seccion1_section-items__bPoOl p {
        font-size: 16px;
    }

    .Seccion1_items-list__fTm6p {
        column-gap: 2%;
        row-gap: 10px;
    }

    .Seccion1_item-detail__U\\+2qv {
        width: 40%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BodyLanding/Seccion1/Seccion1.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oEAAoE;IACpE,wBAAwB;AAC5B;;;AAGA,mBAAmB;AACnB;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;;AAGA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iCAAiC;IACrC;;;IAGA,WAAW;IACX;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA,WAAW;IACX;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA,WAAW;IACX;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;;;IAIA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,UAAU;IACd;;;AAGJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;;IAGA,WAAW;IACX;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;;IAGA,WAAW;IACX;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".container {\n    padding-top: 80px;\n    padding-bottom: 60px;\n}\n\n.first-info-image {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\n.info-text {\n    padding: 70px 0;\n}\n\n.info-text p {\n    font-size: 25px;\n    line-height: 28px;\n    letter-spacing: 0.02em;\n    margin-bottom: 50px;\n}\n\n.info-text p span {\n    font-size: 28px;\n    font-weight: 700;\n}\n\n.image-background {\n    height: 100%;\n    background: url(\"../../../assets/img/chatbot.webp\") no-repeat center;\n    background-size: contain;\n}\n\n\n/* SECTION REPORT */\n.report-container {\n    margin-top: 80px;\n}\n\n.report-container-wrapper {\n    border-radius: 20px;\n    padding: 40px;\n    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);\n}\n\n.report-image-items {\n    display: grid;\n    grid-template-columns: 60% 40%;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #C5C5CA;\n}\n\n.report-image {\n    padding-right: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 30px;\n}\n\n.report-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.report-image a {\n    text-decoration: none;\n    width: max-content;\n}\n\n.report-items {\n    padding: 0 10px 0 40px;\n}\n\n.report-items ul li {\n    margin-bottom: 40px;\n    font-size: 22px;\n    color: var(--black-text);\n}\n\n.report-description {\n    margin-top: 30px;\n    text-align: center;\n    font-size: 22px;\n    color: var(--black-text);\n}\n\n.report-subdescription {\n    display: block;\n    margin-top: 10px;\n    font-family: \"Tenorite\", sans-serif;\n    font-size: 17px;\n    text-align: center;\n}\n\n.report-subdescription a {\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n\n.section-items-container {\n    margin-top: 100px;\n    padding: 60px 0 80px;\n    background: var(--gradient-main);\n}\n\n.section-items h2 {\n    text-align: center;\n    font-size: 46px;\n}\n\n.section-items > p {\n    margin: 30px 0 50px;\n}\n\n.section-items p {\n    text-align: center;\n    font-size: 24px;\n}\n\n.items-list {\n    display: flex;\n    justify-content: center;\n    gap: 3%;\n}\n\n.item-detail {\n    flex: 1;\n    background-color: white;\n    border-radius: 15px;\n    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);\n}\n\n.item-image {\n    width: 60%;\n    height: auto;\n    margin: 0 auto;\n}\n\n.item-image img {\n    width: 100%;\n    height: 100%;\n}\n\n.item-detail p {\n    font-weight: 700;\n    margin-top: 10px;\n    padding: 0 15px 10px;\n}\n\n\n@media screen and (max-width: 1536px) {\n    .first-info-image {\n        grid-template-columns: 60% 40%;\n    }\n\n    .info-text {\n        padding: 60px 0;\n    }\n\n    .info-text p {\n        font-size: 24px;\n    }\n\n    .info-text p span {\n        font-size: 28px;\n    }\n\n    .image-background {\n        background-position: center right;\n    }\n\n\n    /* REPORT */\n    .report-image {\n        padding-right: 30px;\n    }\n\n    .report-items ul li {\n        margin-bottom: 30px;\n        font-size: 20px;\n    }\n\n    .report-description {\n        font-size: 20px;\n    }\n\n\n    .section-items h2 {\n        font-size: 40px;\n    }\n\n    .section-items p {\n        font-size: 22px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .first-info-image {\n        grid-template-columns: 60% 40%;\n    }\n\n    .info-text {\n        padding: 40px 0;\n    }\n\n    .info-text p {\n        font-size: 20px;\n    }\n\n    .info-text p span {\n        font-size: 24px;\n    }\n\n\n    /* REPORT */\n    .report-image {\n        padding-right: 20px;\n    }\n\n    .report-items ul li {\n        margin-bottom: 25px;\n        font-size: 18px;\n    }\n\n    .report-description {\n        font-size: 18px;\n    }\n\n    .report-subdescription {\n        font-size: 15px;\n    }\n\n\n    .section-items h2 {\n        font-size: 36px;\n    }\n\n    .section-items p {\n        font-size: 20px;\n    }\n\n    .items-list {\n        gap: 2%;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .first-info-image {\n        grid-template-columns: 55% 45%;\n    }\n\n    .info-text {\n        padding: 20px 0;\n    }\n\n    .info-text p {\n        font-size: 18px;\n    }\n\n    .info-text p span {\n        font-size: 22px;\n    }\n\n\n    /* REPORT */\n    .report-image-items {\n        grid-template-columns: none;\n    }\n\n    .report-image {\n        padding: 0 50px;\n        grid-row: 2;\n    }\n\n    .report-items {\n        grid-row: 1;\n        padding-left: 30px;\n    }\n\n\n\n    .section-items p {\n        font-size: 18px;\n    }\n\n    .items-list {\n        flex-wrap: wrap;\n        column-gap: 3%;\n        row-gap: 20px;\n    }\n\n    .item-detail {\n        flex: none;\n        width: 28%;\n    }\n\n\n}\n\n@media screen and (max-width: 768px) {\n    .container {\n        padding-top: 60px;\n    }\n\n    .first-info-image {\n        display: flex;\n        flex-direction: column-reverse;\n    }\n\n    .info-text {\n        padding: 10px 5px;\n        text-align: center;\n    }\n\n    .info-text p {\n        margin-bottom: 30px;\n    }\n\n    .info-image {\n        height: 350px;\n    }\n\n\n    /* REPORT */\n    .report-image {\n        padding: 0 30px;\n    }\n\n    .report-items ul li {\n        margin-bottom: 20px;\n    }\n\n\n    .image-background {\n        background-position: center;\n    }\n\n    .section-items h2 {\n        font-size: 34px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .info-text p {\n        font-size: 16px;\n        line-height: 22px;\n    }\n\n    .info-text p span {\n        font-size: 20px;\n    }\n\n    .info-image {\n        height: 300px;\n    }\n\n\n    /* REPORT */\n    .report-container-wrapper {\n        padding: 25px 10px;\n    }\n\n    .report-image {\n        padding: 0;\n    }\n\n    .report-items {\n        padding-left: 20px;\n    }\n\n    .report-items ul li {\n        font-size: 16px;\n    }\n\n    .report-description {\n        font-size: 16px;\n    }\n\n    .report-subdescription {\n        font-size: 14px;\n    }\n\n\n    .section-items h2 {\n        font-size: 30px;\n    }\n\n    .section-items p {\n        font-size: 16px;\n    }\n\n    .items-list {\n        column-gap: 2%;\n        row-gap: 10px;\n    }\n\n    .item-detail {\n        width: 40%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Seccion1_container__LQxtt`,
	"first-info-image": `Seccion1_first-info-image__jZNAe`,
	"info-text": `Seccion1_info-text__Ge7BH`,
	"image-background": `Seccion1_image-background__5zMiA`,
	"report-container": `Seccion1_report-container__jpvNl`,
	"report-container-wrapper": `Seccion1_report-container-wrapper__yB1sH`,
	"report-image-items": `Seccion1_report-image-items__RjyC1`,
	"report-image": `Seccion1_report-image__hLrKv`,
	"report-items": `Seccion1_report-items__GPRR8`,
	"report-description": `Seccion1_report-description__dWirx`,
	"report-subdescription": `Seccion1_report-subdescription__Y9DHb`,
	"section-items-container": `Seccion1_section-items-container__ofh+v`,
	"section-items": `Seccion1_section-items__bPoOl`,
	"items-list": `Seccion1_items-list__fTm6p`,
	"item-detail": `Seccion1_item-detail__U+2qv`,
	"item-image": `Seccion1_item-image__n6vXI`,
	"info-image": `Seccion1_info-image__zx2B0`
};
export default ___CSS_LOADER_EXPORT___;
